import { render, staticRenderFns } from "./MultipleBox.vue?vue&type=template&id=46ac4912&scoped=true"
import script from "./MultipleBox.vue?vue&type=script&lang=js"
export * from "./MultipleBox.vue?vue&type=script&lang=js"
import style0 from "./MultipleBox.vue?vue&type=style&index=0&id=46ac4912&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ac4912",
  null
  
)

export default component.exports